import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";

const api = new APIClient();

export const getAllTaxListService = (params = {}) => {
  return api.get(url.GET_TAX_LIST, params);
};

export const addTaxMasterService = (requestParam = {}) => {
  return api.create(url.POST_TAX_MASTER, requestParam);
};

export const updateTaxMasterervice = (requestParam) => {
  return api.create(url.PUT_TAX_MASTER, requestParam);
};

// export const getUserDetailsService = (id) => {
//   return api.get(url.GET_USER(id));
// };

export const deleteTaxMasterService = (id) => {
  return api.delete(url.DELETE_TAX_MASTER(id));
};

export const updateTaxStatusService = (id, status, data = {}) => {
  return api.put(url.PUT_TAX_STATUS(id), data, status, true);
};
